$(document).ready(function () {
    initAside();
    initTooltip($('.aside [data-toggle="tooltip"]'), 'body');
    initTooltip($('.content-header [data-toggle="tooltip"]'), '.content-header');
    initTooltip($('.content-body [data-toggle="tooltip"]'));
    initClipboard();
    initTable();
    initNoty();
    initMasks();
});

function initSelect2(selector) {
    if (selector === undefined) {
        selector = $('select.select2');
    }
    selector.select2({
        allowClear: true,
        placeholder: gettext('Select value')
    }).on('select2:unselecting', function () {
        $(this).data('unselecting', true);
    }).on('select2:opening', function (e) {
        if ($(this).data('unselecting')) {
            $(this).removeData('unselecting');
            e.preventDefault();
        }
    });
}

function initMasks() {
    $('[data-mask]').each(function () {
        let type = $(this).data('mask');
        let mask;

        if (type === 'phone') {
            let phone_code = $(this).data('phone-code');
            mask = $(this).data('phone-mask');
            if (phone_code) {
                mask = phone_code + ' ' + mask;
            }
        }

        if (mask) {
            $(this).mask(mask);
        }
    });
}

function initNoty() {
    let noty_message = $('[data-init-noty-message]').data('init-noty-message');
    let noty_type = $('[data-init-noty-type]').data('init-noty-type');
    if (noty_message.length === 0) {
        return;
    }
    if (noty_type.length === 0) {
        noty_type = 'success';
    }
    showNoty(noty_type, noty_message);
}

function initTable() {
    let block = $('table.table');
    if (block.length === 0) {
        return;
    }

    block.on('click', 'thead [type="checkbox"]', function () {
        let check = !!$(this).prop('checked');
        $(this).closest('table').find('[type="checkbox"]').not(this).prop('checked', check).attr('checked', check);
    });
}

function initClipboard() {
    let clipboards = new ClipboardJS('[data-clipboard]');
    clipboards.on('success', function (e) {
        e.clearSelection();
        showNoty('success', gettext('Copied'));
    });
}

function initAside() {
    $('body')
        .on('click', '.aside-menu-link', function () {
            let status = Cookies.get('aside_hide');
            status = status !== 'true';
            Cookies.set('aside_hide', status);
            $('aside.aside').toggleClass('minimized');
        })
    ;
}

function initTooltip(items, container) {
    if (container === undefined) {
        container = '.content-body';
    }
    items.tooltip({
        container: container,
        trigger: 'hover'
    });
}

function showNoty(type, message, timeout=null) {
    let default_timeout = 3000;
    if (type === 'error') {
        default_timeout = 5000;
    }
    if (timeout !== null) {
        default_timeout = timeout;
    }
    new Noty({
        type: type,
        text: message,
        timeout: default_timeout,
    }).show();
}

function confirmModal(that, callback, prepare) {
    let confirm = that.data('confirm');
    if (confirm) {
        let title = that.data('original-title') ? that.data('original-title') : that.attr('title');

        let modal = $('#confirmModal');
        $('.modal-extra', modal).empty();
        $('.confirm-modal-text', modal).text(title + '?');
        $('.confirm-modal-btn', modal).unbind('click').on('click', function () {
            callback();
            modal.modal('hide');
        });
        modal.attr('data-type', confirm);
        if (typeof prepare !== 'undefined') {
            prepare();
        }
        modal.modal();
    } else {
        callback();
    }
}

function _(text) {
    return gettext(text);
}

Highcharts.setOptions({
    colors: [
        '#058DC7',
        '#50B432',
        '#ED561B',
        '#DDDF00',
        '#24CBE5',
        '#FF9655',
        '#64E572',
        '#FFF263',
        '#6AF9C4',
    ],
    lang: {
        loading: 'Loading ...',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        shortMonths: ['Jan', 'Feb', 'March', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        exportButtonTitle: "Export",
        printButtonTitle: "Print",
        rangeSelectorFrom: "С",
        rangeSelectorTo: "By",
        rangeSelectorZoom: "Period",
        downloadPNG: 'Download PNG',
        downloadJPEG: 'Download JPEG',
        downloadPDF: 'Download PDF',
        downloadSVG: 'Download SVG',
        printChart: 'Print Graph'
    }
});

function hcFillColor(color) {
    return {
        linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
        },
        stops: [
            [0, Highcharts.color(Highcharts.getOptions().colors[color]).setOpacity(0.3).get('rgba')],
            [1, Highcharts.color(Highcharts.getOptions().colors[color]).setOpacity(0).get('rgba')]
        ]
    };
}

function sendPost(url, data, callback) {
    data['csrfmiddlewaretoken'] = $('input[name="csrfmiddlewaretoken"]').prop('value');
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (response) {
            callback(response);
        },
        error: function (response) {
            console.log(response.responseJSON);
        }
    });
}


function changeLanguage(language) {
    let url = '/language';
    let data = {
        lang: language,
        csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
    };

    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (response) {
            location.reload();
        },
        error: function (response) {
            showNoty('error', response.responseJSON.message);
        }
    });
}


function sendApiGet(url, callback) {
    let authorizationToken = 'Token ' + $('[name="token"]').attr('content');

    $.ajax({
        type: 'GET',
        url: url,
        beforeSend: function (request) {
            request.setRequestHeader('Authorization', authorizationToken);
        },
        success: function (response) {
            callback(response);
        },
        error: function (response) {
            console.log(response.responseJSON);
        }
    });
}


function getCurrentDateWithoutSecondsAndMilliseconds() {
    let now = new Date();
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now.getTime();
}